export const UI_BUTTON_PRIMARY = 'primary';
export const UI_BUTTON_SECONDARY = 'secondary';

export const UI_BUTTON_MICRO = 'small';
export const UI_TAG_PRIMARY = 'ts-info';

export const UI_CLASS_COMPANY_SETTINGS_DOMAIN = 'domain';

export const UI_CLASS_PAGE_SETTINGS_NO_CODING_CONTENT = 'coding content';
export const UI_CLASS_PAGE_SETTINGS_NO_CODING_PANEL = 'empty-state';

export const UI_SVG_EMPTY_STATE = 'empty-state-illustration';

export const UI_SIDE_MENU = 'side-menu';
export const UI_SIDE_MENU_COLLAPSED = 'side-menu-collapsed';
export const UI_SIDE_MENU_OPEN = 'side-menu-open';
export const UI_SIDE_MENU_MOBILE_VIEW_OPEN = 'side-menu-mobile-view-open';
